import { useQuery } from "@tanstack/react-query";
import { useDataSource } from "@/data/DataProvider";
import { useIdentity } from "@/auth/ClientAuthProvider";
import type { SharedPresentation } from "@/data/types";

export type { SharedPresentation };

/** The newest presentation the team shared to the app. */
export function usePresentation() {
  const source = useDataSource();
  const id = useIdentity();
  return useQuery({
    queryKey: ["presentation", id.orgId, id.leadId],
    queryFn: () => source.getPresentation(id),
    staleTime: 5 * 60_000,
  });
}

export function presentationTypeLabel(type: string | null | undefined): string {
  switch (type) {
    case "iul_plan":
      return "Tax-free retirement plan";
    case "retirement_gap_plan":
      return "Retirement income plan";
    case "protection_savings_plan":
      return "Protection and savings plan";
    default:
      return "Your strategy";
  }
}
